<template>
  <b-form
    @submit.prevent="handlerSubmit"
    class="d-flex flex-wrap justify-content-center align-items-center"
  >
    <input
      type="text"
      v-model="title"
      placeholder="Add Title"
      class="atm-input-title w-100 mb-4"
      required
      :readonly="readonly"
    />
    <b-input-group class="mb-4">
      <b-form-select
        :disabled="!typeClass.length || readonly"
        v-model="subject"
        class="atm-input text-capitalize"
        :options="typeClass"
      >
      </b-form-select>
      <b-input-group-prepend v-if="!typeClass.length" is-text>
        <b-spinner small label="Classes Loading..."></b-spinner>
      </b-input-group-prepend>
    </b-input-group>
    <div class="d-flex flex-wrap align-items-center mb-4 w-100">
      <div class="align-items-center d-flex mt-3 font-weight-bolder">
        <i class="material-icons mr-2">event_available</i>
        <span>When is it due?*</span>
      </div>
      <div class="d-flex justify-content-between w-100">
        <input v-model="dueDate" type="date" class="atm-input-time" required :readonly="readonly" />
        <input v-model="dueHour" type="time" class="atm-input-time" :readonly="readonly" />
      </div>
    </div>

    <b-button type="sumbit" class="atm-button bg-main mx-auto w-50" v-show="!readonly">
      <b-spinner v-if="loaderSaved" label="Save" />
      <span v-else>Save</span>
    </b-button>
  </b-form>
</template>

<script>
import { getDate, getPlainHour } from '@/plugins/utils';
import { formatLongDateTime } from '@/common/utils/Date';

export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
    typeClass: {
      type: Array,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '',
      subject: null,
      dueDate: getDate(),
      dueHour: getPlainHour(),
      loaderSaved: false,
    };
  },
  methods: {
    handlerSubmit() {
      this.loaderSaved = true;
      const newProject = {
        title: this.title,
        subject: this.subject,
        due_date: this.dueDate,
        due_hour: this.dueHour,
      };
      this.$emit('createOrEditProject', { newProject });
    },
  },
  watch: {
    project: {
      handler: function(val) {
        const date = formatLongDateTime(val.due_date);
        const dueDate = getDate(date);
        const dueHour = getPlainHour(date);
        this.title = val.title;
        this.subject = val.subject?.id || val.subject;
        this.dueDate = dueDate;
        this.dueHour = dueHour;
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>

